import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

export const IconFilter = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <rect width="24" height="24" />
            <path
                d="m11 3c1.3063 0 2.4175 0.83485 2.8293 2.0001l7.1707-8.893e-5c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1l-7.171 9.0072e-4c-0.41209 1.1647-1.5231 1.9991-2.829 1.9991-1.3059 0-2.4169-0.83438-2.829-1.9991l-5.171-9.0072e-4c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1l5.1707 8.893e-5c0.41181-1.1652 1.5231-2.0001 2.8293-2.0001zm0 2c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1z"
                fill="#fff"
            />
            <path
                d="m17 9c1.3063 0 2.4175 0.83485 2.8293 2.0001l1.1707-8.89e-5c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1l-1.171 9.007e-4c-0.41209 1.1647-1.5231 1.9991-2.829 1.9991s-2.4169-0.83438-2.829-1.9991l-11.171-9.007e-4c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1l11.171 8.89e-5c0.41181-1.1652 1.5231-2.0001 2.8293-2.0001zm0 2c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1z"
                fill="#fff"
            />
            <path
                d="m7 15c1.3063 0 2.4175 0.83485 2.8293 2.0001l11.171-8.89e-5c0.55228 0 1 0.44772 1 1s-0.44772 1-1 1l-11.171 9.007e-4c-0.41209 1.1647-1.5231 1.9991-2.829 1.9991s-2.4169-0.83438-2.829-1.9991l-1.171-9.007e-4c-0.55228 0-1-0.44772-1-1s0.44772-1 1-1l1.1707 8.89e-5c0.41181-1.1652 1.5231-2.0001 2.8293-2.0001zm0 2c-0.55228 0-1 0.44772-1 1s0.44772 1 1 1 1-0.44772 1-1-0.44772-1-1-1z"
                fill="#fff"
            />
        </g>
    </SvgIcon>
);
